import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import {LoaderService} from 'src/app/shared/services/loader/loader.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'angular-master';
  showLoader: boolean = false;
  loaderStatus: Subscription = new Subscription();

  constructor(
    public loaderService: LoaderService,
    private cdr: ChangeDetectorRef
  ){

  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent) {
    if(event){
      this.loaderService.isShowDialog(false);
    }
  }

  ngAfterViewInit() {
    this.loaderStatus = this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    if(this.loaderStatus) {
      this.loaderStatus.unsubscribe();
    }
  }

}
